<template>
        <div class="relative w-100 header-min">
            <div class="row align-items-end no-gutters">
                <div class="d-sm-flex d-md-none header-background" v-if="!isHidden">
                </div>

                <a href="/">
                    <div class="">
                        <img class="logo" src="../../../static/images/1x/livio_logo.png" srcset="../../../static/images/2x/livio_logo@2x.png 2x, ../../../static/images/3x/livio_logo@3x.png 3x" />
                    </div>
                </a>
                <div class="col no-gutters d-none d-sm-block between">
                </div>
                <div class="col d-xs-flex d-sm-none header-spacer">
                </div>
                <div class="no-gutters d-none d-md-inline-block">
                    <div class="rectangle">
                        <div class="code-coffee-create">
                            Code. Coffee. Create.
                        </div>
                    </div>
                </div>

                <button class="d-sm-flex d-md-none header-open-dropdown" v-on:click="isHidden=!isHidden" v-if="isHidden">
                    <a class="fa fa-chevron-down fa-2x livio-blue" style="color:#49C7ED"></a>
                </button>
                <button class="d-sm-flex d-md-none header-close-dropdown" v-on:click="isHidden=!isHidden" v-if="!isHidden">
                    <a class="fa fa-chevron-up fa-2x livio-blue" style="color:#49C7ED"/>
                </button>
                <div class="navbar-collapse d-lg-none d-xl-block">
                    <ul class="d-md-none nav nav-pills flex-column d-md-none w-100 header-dropdown" v-if="!isHidden">
                        <router-link to="/portfolio">
                            <a href="/portfolio" class="portfolio-team-caree">Portfolio</a>
                        </router-link>
                        <router-link to="/team">
                            <a href="/team" class="portfolio-team-caree">Team</a>
                        </router-link>
                        <router-link to="/careers">
                            <a href="/careers" class="portfolio-team-caree">Careers</a>
                        </router-link>
                        <router-link to="/ces">
                            <a href="/ces" class="portfolio-team-caree">CES</a>
                        </router-link>
                        <router-link to="/office">
                            <a href="/office" class="portfolio-team-caree">Office</a>
                        </router-link>
                    </ul>
                </div>
            </div>
        </div>
</template>

<script>
    export default {
        data: function(){
            return {
                isHidden: true,
            };
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/shared/Header.vue